const config = {
  API_URL: process.env.REACT_APP_API_URL || "https://nature-mart-project.onrender.com",
};
 
export default config;
 